import React from 'react';

const Privacy = () => {
  return (
    <div>
      {/* Privacy Hero Section */}
      <section className="privacy-hero">
        <div className="container">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">Privacy Policy</h1>
          <p className="text-xl max-w-2xl mx-auto">Last updated: September 2023</p>
        </div>
      </section>

      {/* Privacy Content */}
      <section className="privacy-content">
        <div className="container">
          <div className="max-w-3xl mx-auto">
            <div className="privacy-section">
              <h2>Introduction</h2>
              <p>At Cleophas Network, we respect your privacy and are committed to protecting your personal data. This privacy policy will inform you about how we look after your personal data when you visit our website and tell you about your privacy rights and how the law protects you.</p>
            </div>
            
            <div className="privacy-section">
              <h2>1. Important Information and Who We Are</h2>
              <h3>Purpose of This Privacy Policy</h3>
              <p>This privacy policy aims to give you information on how Cleophas Network collects and processes your personal data through your use of this website, including any data you may provide through this site when you sign up for our service, purchase a product, or take part in a competition.</p>
              
              <h3>Controller</h3>
              <p>Cleophas Network is the controller and responsible for your personal data (referred to as "we", "us" or "our" in this privacy policy).</p>
            </div>
            
            <div className="privacy-section">
              <h2>2. The Data We Collect About You</h2>
              <p>We may collect, use, store, and transfer different kinds of personal data about you which we have grouped together as follows:</p>
              
              <h3>Identity Data</h3>
              <p>Includes first name, last name, username or similar identifier.</p>
              
              <h3>Contact Data</h3>
              <p>Includes billing address, delivery address, email address, and telephone numbers.</p>
              
              <h3>Technical Data</h3>
              <p>Includes internet protocol (IP) address, your login data, browser type and version, time zone setting and location, browser plug-in types and versions, operating system and platform, and other technology on the devices you use to access this website.</p>
              
              <h3>Usage Data</h3>
              <p>Includes information about how you use our website, products, and services.</p>
              
              <h3>Marketing and Communications Data</h3>
              <p>Includes your preferences in receiving marketing from us and our third parties and your communication preferences.</p>
            </div>
            
            <div className="privacy-section">
              <h2>3. How We Use Your Personal Data</h2>
              <p>We will only use your personal data when the law allows us to. Most commonly, we will use your personal data in the following circumstances:</p>
              
              <ul className="list-disc pl-5 mb-4">
                <li>Where we need to perform the contract we are about to enter into or have entered into with you.</li>
                <li>Where it is necessary for our legitimate interests (or those of a third party) and your interests and fundamental rights do not override those interests.</li>
                <li>Where we need to comply with a legal obligation.</li>
              </ul>
              
              <p>Generally, we do not rely on consent as a legal basis for processing your personal data although we will get your consent before sending third party direct marketing communications to you via email or text message.</p>
            </div>
            
            <div className="privacy-section">
              <h2>4. Data Security</h2>
              <p>We have put in place appropriate security measures to prevent your personal data from being accidentally lost, used, or accessed in an unauthorized way, altered, or disclosed. In addition, we limit access to your personal data to those employees, agents, contractors, and other third parties who have a business need to know.</p>
            </div>
            
            <div className="privacy-section">
              <h2>5. Data Retention</h2>
              <p>We will only retain your personal data for as long as reasonably necessary to fulfill the purposes we collected it for, including for the purposes of satisfying any legal, regulatory, tax, accounting, or reporting requirements.</p>
            </div>
            
            <div className="privacy-section">
              <h2>6. Your Legal Rights</h2>
              <p>Under certain circumstances, you have rights under data protection laws in relation to your personal data including the right to:</p>
              
              <ul className="list-disc pl-5 mb-4">
                <li>Request access to your personal data</li>
                <li>Request correction of your personal data</li>
                <li>Request erasure of your personal data</li>
                <li>Object to processing of your personal data</li>
                <li>Request restriction of processing your personal data</li>
                <li>Request transfer of your personal data</li>
                <li>Right to withdraw consent</li>
              </ul>
              
              <p>If you wish to exercise any of the rights set out above, please contact us at cleophaske254@gmail.com.</p>
            </div>
            
            <div className="privacy-section">
              <h2>7. Contact Us</h2>
              <p>If you have any questions about this privacy policy or our privacy practices, please contact us at:</p>
              
              <div className="bg-blue-50 p-6 rounded-lg mt-6">
                <p className="mb-2">
                  <strong>Email:</strong> cleophaske254@gmail.com
                </p>
                <p className="mb-4">
                  <strong>WhatsApp:</strong> +254 115 647 545
                </p>
                <a href="https://wa.me/254115647545?text=I%20have%20questions%20about%20privacy%20policy" 
                   className="inline-flex items-center bg-green-500 hover:bg-green-600 text-white font-bold py-2 px-4 rounded-lg transition-colors text-sm">
                  <i className="fab fa-whatsapp mr-2"></i> Message Us on WhatsApp
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Privacy;